import { ValueOf } from '@vy/utils';

export const AUTO_RENEW_CONTRACT_STEPS = Object.freeze({
  Preferences: 0,
});

export type AutoRenewContractStep = ValueOf<typeof AUTO_RENEW_CONTRACT_STEPS>;
